import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import NavbarModuloLF from '../../components/NavbarModuloFage';
import classNames from 'classnames';
import DetalleListado from './DetalleAumentos';
const valEmp = __CONFIG__.empresa;

import {
    AsyncSelectField,
    AsyncSelectFieldIn,
    renderDayPickerB,
    renderCurrencyFloat
} from "../../Utils/renderField/renderField";

function AumentoSalarioForm(props) {
    const { modulo, listarColaborador, listarPaises, emp, guardarSalario,
        datosColaborador, cargo, historialSal, eliminarLinea } = props;
    let titulo = 'Aumento salario colaborador';
    
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    const handleOnChange = value => {
        listarColaborador(value.value);
    };

    const handleOnChangeEmp = value => {
        datosColaborador(value.value);
    };

    const estilo = {
        overflow: "auto",
        height: "300px",

    };

    return (
        <div>
            {valEmp === 'fage' &&
                <NavbarModuloLF
                    modulo={modulo}
                    titulo={titulo}
                />
            }
            {valEmp === '' &&
                <NavbarModulo
                    modulo={modulo}
                    titulo={titulo}
                />
            }
           
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='mb-2'>
                            <div className='row mb-2'>
                                <div className='col-6'>
                                    <Field
                                        name="pais"
                                        placeholder="Pais..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        loadOptions={listarPaises}
                                        onChange={handleOnChange}
                                        msj="Pais"
                                    />
                                </div>
                            </div>
                            <div className='row mb-2'>
                                <div className='col-6'>
                                    <Field
                                        name="colaborador"
                                        placeholder="Colaborador..."
                                        className="form-control-find"
                                        component={AsyncSelectFieldIn}
                                        loadOptions={emp}
                                        onChange={handleOnChangeEmp}
                                        msj="Colaborador"
                                    />
                                </div>
                                <div className='col-6'>
                                    <div className="form-floating">
                                        <input
                                            className = {classNames('form-control')}
                                            type="text"
                                            value = {cargo}
                                            disabled = {true}
                                        />
                                        <label className='form-label'>Puesto</label>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <div className='col-3 ml-2'>
                                    <Field
                                        name="fecha_inicio"
                                        component={renderDayPickerB}
                                        msj="Fecha inicio"
                                    />
                                </div>
                                <div className='col-3'>
                                    <Field
                                        name="sueldo_base"
                                        placeholder="Sueldo base"
                                        className="form-control"
                                        component={renderCurrencyFloat}
                                        msj="Sueldo base"
                                    />
                                </div>
                                <div className='col-3'>
                                    <Field
                                        name="bonificacion"
                                        placeholder="Bonificacion"
                                        className="form-control"
                                        component={renderCurrencyFloat}
                                        msj="Bonificacion"
                                    />
                                </div>
                            </div>
                            <div className='mt-3' style={estilo}>
                                <DetalleListado
                                    detalle={historialSal}
                                    eliminarLinea={eliminarLinea}
                                />
                            </div>
                            <div className='d-flex flex-row mt-3 ml-2'>
                                
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={guardarSalario}
                                >
                                    Guardar salario
                                </button>
                                {valEmp === 'fage' &&
                                    <a
                                        href={`/#/lfg/rr_hh/${id_emp[6]}`}
                                        className='btn btn-secondary mb-3'
                                    >
                                        Regresar
                                    </a>
                                }
                                {valEmp === '' &&
                                    <a
                                        href={`/#/rr_hh/${id_emp[5]}`}
                                        className='btn btn-secondary mb-3'
                                    >
                                        Regresar
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

AumentoSalarioForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object
};

export default reduxForm({
    form: 'FormAumentoSalarioColaborador',
})(AumentoSalarioForm);
